import { rf_color } from 'console/tabs/legacy/rf/rf-utils';
import { getSensorColor } from 'z3k-settings/components/utils/ColorPicker4bit';
import { AnalogInput, AnalogOutput, AnalogTemperatureSensor, HeatingCircuit, RadioSensor, WebElement, WiredTemperatureSensor, } from 'z3k-config';
import { owaMultiplier } from 'console/device-settings/owa';
import { BooleanMarkingsGraphSource, GraphSource, TemperatureGraphData } from './base';
import { ot_flag_graphs, ot_line_graphs, OTZoneFlagGraph, OTZoneLineGraph, } from './opentherm';
import * as cf from './common';
import { normalize_time } from './common';
import { BaseBoilerWorkTime } from './thermostat';
import { z3k_key_namespace } from 'z3k-settings/utils/namespaces';
import { LoadDataType } from '../load-types';
import { owaAxis } from 'console/tabs/graphs/components/graph/utils/owa-axes';
export function find_by_id(array, id) {
    for (const obj of array != null ? array : []) {
        if (obj.id === id) {
            return obj;
        }
    }
    return null;
}
export class BaseZ3K extends TemperatureGraphData {
    array_name() {
        return 'analog_inputs';
    }
    device;
    object_id;
    constructor(device, { object_id, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.device = device;
        this.object_id = object_id;
        this._color = color;
    }
    serialize_params() {
        return { object_id: this.object_id, color: this._color };
    }
    is_same(other) {
        return (this.constructor === other.constructor && this.object_id === other.object_id);
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ?? null);
    }
    title() {
        return this.get_object()?.name ?? '<удалён>';
    }
}
export class WiredTemperatureGraphData extends BaseZ3K {
    class_name() {
        return 'WiredTemperatureGraphData';
    }
    array_name() {
        return 'wired_temperature_sensors';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ?? null);
    }
    color() {
        if (this._color)
            return this._color;
        return getSensorColor(WiredTemperatureSensor, this.get_object());
    }
    data_source_key() {
        return LoadDataType.z3k_temperature;
    }
    yaxis_key() {
        return owaAxis(this.get_object()?.serial) ?? 'temperature';
    }
    extract_data(raw_data) {
        // console.log('WiredTemperatureGraphData extract_data', raw_data);
        return raw_data?.[this.object_id] ?? [];
    }
    normalize_data(data) {
        const result = super.normalize_data(data);
        const mult = owaMultiplier({
            serial: this.get_object()?.serial,
            sensor: this.get_object(),
        });
        if (mult === 1)
            return result;
        return result.map(([time, value]) => [
            time,
            value != null ? value * mult : null,
        ]);
    }
}
export class AnalogTemperatureGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogTemperatureGraphData';
    }
    array_name() {
        return 'analog_temperature_sensors';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ?? null);
    }
    color() {
        if (this._color)
            return this._color;
        return getSensorColor(AnalogTemperatureSensor, this.get_object());
    }
    data_source_key() {
        return LoadDataType.z3k_temperature;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id] ?? [];
    }
}
export class Z3KOTZoneLineGraph extends OTZoneLineGraph {
    class_name() {
        return 'Z3KOTZoneLineGraph';
    }
    object_id;
    ot_field;
    constructor(device, { object_id, ot_field, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.object_id = object_id;
        this.ot_field = ot_field;
        this._device_name = find_by_id(device.z3k_config()?.boiler_adapters, object_id)?.name;
    }
    serialize_params() {
        return { object_id: this.object_id, ot_field: this.ot_field, color: this._color };
    }
    is_same(other) {
        return (
        //@ts-ignore
        super.is_same(...arguments) &&
            this.object_id === other.object_id &&
            this.ot_field === other.ot_field);
    }
    data_source_key() {
        return LoadDataType.z3k_boiler_adapter;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.[this.ot_field];
    }
    static all_for_object_id(device, object_id) {
        return ot_line_graphs.map((spec) => new this(device, { object_id, ot_field: spec.field }));
    }
}
export class Z3KOTZoneFlagGraph extends OTZoneFlagGraph {
    class_name() {
        return 'Z3KOTZoneFlagGraph';
    }
    object_id;
    ot_flag;
    constructor(device, { object_id, ot_flag, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.object_id = object_id;
        this.ot_flag = ot_flag;
        this._color = color;
        this._device_name = find_by_id(device.z3k_config()?.boiler_adapters, object_id)?.name;
    }
    serialize_params() {
        return { object_id: this.object_id, ot_flag: this.ot_flag, color: this._color };
    }
    is_same(other) {
        return (
        //@ts-ignore
        super.is_same(...arguments) &&
            this.object_id === other.object_id &&
            this.ot_flag === other.ot_flag);
    }
    data_source_key() {
        return LoadDataType.z3k_boiler_adapter;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.s;
    }
    static all_for_object_id(device, object_id) {
        return ot_flag_graphs.map((spec) => new this(device, { object_id, ot_flag: spec.flag }));
    }
}
export class Z3KOTFailGraph extends Z3KOTZoneFlagGraph {
    class_name() {
        return 'Z3KOTFailGraph';
    }
    constructor(device, { object_id, color }) {
        super(device, { object_id, ot_flag: 'f', color: color });
    }
    serialize_params() {
        return { object_id: this.object_id, color: this._color };
    }
    is_same(other) {
        //@ts-ignore
        return super.is_same(...arguments) && this.object_id === other.object_id;
    }
    title() {
        return this._device_name
            ? `ошибка котла (${this._device_name})`
            : 'ошибка котла';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(229,0,0,0.4)';
    }
}
export class BaseRadioSensorGraph extends GraphSource {
    device;
    object_id;
    constructor(device, { object_id }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.device = device;
        this.object_id = object_id;
    }
    serialize_params() {
        return { object_id: this.object_id, color: this._color };
    }
    is_same(other) {
        //@ts-ignore
        // eslint-disable-next-line prefer-rest-params
        return super.is_same(...arguments) && this.object_id === other.object_id;
    }
    get_object() {
        return find_by_id(this.device.z3k_config()?.radiosensors, this.object_id);
    }
    title() {
        const title = `${this.get_object()?.name ?? '<удалено>'}: ${this.radio_graph_name()}`;
        return title;
    }
    color() {
        if (this._color)
            return this._color;
        return getSensorColor(RadioSensor, this.get_object());
    }
    radio_graph_name() {
        return '???';
    }
    data_source_key() {
        return LoadDataType.z3k_radio_sensor;
    }
    getter(prop) { }
    gap_width() {
        return 30 * 60;
    }
    extract_data(raw_data) {
        return this.getter(raw_data?.[this.object_id]);
    }
    normalize_data(data) {
        return cf.time_mul_1k(cf.add_gaps(cf.normalize_time(data, 0), this.gap_width()));
    }
}
export class Z3KRadioSensorFlag extends BooleanMarkingsGraphSource {
    device;
    object_id;
    constructor(device, { object_id }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.device = device;
        this.object_id = object_id;
    }
    serialize_params() {
        return { object_id: this.object_id, color: this._color };
    }
    radio_graph_name() { }
    is_same(other) {
        //@ts-ignore
        return super.is_same(...arguments) && this.object_id === other.object_id;
    }
    get_object() {
        return find_by_id(this.device.z3k_config()?.radiosensors, this.object_id);
    }
    title() {
        return `${this.get_object()?.name ?? '<удалено>'}: ${this.radio_graph_name()}`;
    }
    data_source_key() {
        return LoadDataType.z3k_radio_sensor;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.flags;
    }
    normalize_data(data) {
        return cf.normalize_time(data, 0);
    }
}
export class HeatingCircuitSummerModeGraphData extends Z3KRadioSensorFlag {
    class_name() {
        return 'HeatingCircuitSummerModeGraphData';
    }
    array_name() {
        return 'heating_circuits';
    }
    //@ts-ignore
    get_object() {
        return find_by_id(this.device.z3k_config()?.heating_circuits, this.object_id);
    }
    title() {
        return this.get_object()?.name + ': летний режим';
    }
    color() {
        if (this._color) {
            return this._color;
        }
        return '#f0801e';
    }
    data_source_key() {
        return LoadDataType.z3k_heating_circuit;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.status;
    }
    predicate(value) {
        return value & HeatingCircuit.StatusFlags.CIRCUIT_IN_SUMMER_MODE;
    }
    normalize_data(data) {
        return cf.normalize_time(data, 0);
    }
}
export class Z3KRadioSensorBattery extends BaseRadioSensorGraph {
    class_name() {
        return 'Z3KRadioSensorBattery';
    }
    radio_graph_name() {
        return 'аккумулятор';
    }
    yaxis_key() {
        return 'voltage';
    }
    getter(obj_data) {
        return obj_data?.battery;
    }
}
export class Z3KRadioSensorDbm extends BaseRadioSensorGraph {
    class_name() {
        return 'Z3KRadioSensorDbm';
    }
    radio_graph_name() {
        return 'сигнал';
    }
    yaxis_key() {
        return 'dbm';
    }
    getter(obj_data) {
        return obj_data?.dbm;
    }
}
export class Z3KRadioSensorHumidity extends BaseRadioSensorGraph {
    class_name() {
        return 'Z3KRadioSensorHumidity';
    }
    radio_graph_name() {
        return 'влажность';
    }
    yaxis_key() {
        return 'percent';
    }
    getter(obj_data) {
        return obj_data?.humidity;
    }
}
export class Z3KRadioSensorTemperature extends BaseRadioSensorGraph {
    class_name() {
        return 'Z3KRadioSensorTemperature';
    }
    radio_graph_name() {
        return 'температура';
    }
    yaxis_key() {
        return 'temperature';
    }
    getter(obj_data) {
        return obj_data?.temperature;
    }
}
const RadioSensorFlags = {
    RSS_SIGNAL_LOST: 1 << 0,
    RSS_TEMPERATURE_HIGH: 1 << 2,
    RSS_LEAKAGE: 1 << 5,
    RSS_MOTION: 1 << 6,
    RSS_TEMPERATURE_ALARM: 1 << 7,
    RSS_HUMIDITY_ALARM: 1 << 8,
};
export class Z3KRadioSensorMovement extends Z3KRadioSensorFlag {
    class_name() {
        return 'Z3KRadioSensorMovement';
    }
    radio_graph_name() {
        return 'движение';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(0,0,229,0.4)';
    }
    predicate(value) {
        return value & RadioSensorFlags.RSS_MOTION;
    }
}
export class Z3KRadioSensorLost extends Z3KRadioSensorFlag {
    class_name() {
        return 'Z3KRadioSensorLost';
    }
    radio_graph_name() {
        return 'Отсутствие сигнала';
    }
    color() {
        if (this._color) {
            return this._color;
        }
        return 'rgba(138,136,136,0.4)';
    }
    predicate(value) {
        // console.log('Z3KRadioSensorLost predicate', value);
        return value & RadioSensorFlags.RSS_SIGNAL_LOST;
    }
}
export class Z3KRadioSensorLeakage extends Z3KRadioSensorFlag {
    class_name() {
        return 'Z3KRadioSensorLeakage';
    }
    radio_graph_name() {
        return 'протечка';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(229,0,0,0.4)';
    }
    predicate(value) {
        return value & RadioSensorFlags.RSS_LEAKAGE;
    }
}
export class Z3KRadioSensorTemperatureAlarm extends Z3KRadioSensorFlag {
    class_name() {
        return 'Z3KRadioSensorTemperatureAlarm';
    }
    radio_graph_name() {
        return 'температура за пределами';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(229,0,0,0.4)';
    }
    predicate(value) {
        return value & RadioSensorFlags.RSS_TEMPERATURE_ALARM;
    }
}
export class Z3KRadioSensorHumidityAlarm extends Z3KRadioSensorFlag {
    class_name() {
        return 'Z3KRadioSensorHumidityAlarm';
    }
    radio_graph_name() {
        return 'влажность за пределами';
    }
    color() {
        if (this._color)
            return this._color;
        return 'rgba(229,0,0,0.4)';
    }
    predicate(value) {
        return value & RadioSensorFlags.RSS_HUMIDITY_ALARM;
    }
}
export const create_z3k_radio_sources = (device, object //////////????????????
) => Array.from((function* () {
    switch (object.type) {
        case RadioSensor.Type.LEAK: // MLW
            yield new Z3KRadioSensorLeakage(device, {
                object_id: object.id,
            });
            break;
        case RadioSensor.Type.MOTION: // MLM
            yield new Z3KRadioSensorTemperature(device, {
                object_id: object.id,
            });
            yield new Z3KRadioSensorMovement(device, {
                object_id: object.id,
            });
            yield new Z3KRadioSensorTemperatureAlarm(device, {
                object_id: object.id,
            });
            break;
        case RadioSensor.Type.TEMPERATURE_A:
        case RadioSensor.Type.TEMPERATURE_B:
        case RadioSensor.Type.TEMPERATURE_C: // MLT
        case RadioSensor.Type.RADIO_DISPLAY_TEMPERATURE: // ML-332
            yield new Z3KRadioSensorTemperature(device, {
                object_id: object.id,
            });
            yield new Z3KRadioSensorTemperatureAlarm(device, {
                object_id: object.id,
            });
            break;
        case RadioSensor.Type.HUMIDITY: // MLH
            yield new Z3KRadioSensorHumidity(device, {
                object_id: object.id,
            });
            yield new Z3KRadioSensorHumidityAlarm(device, {
                object_id: object.id,
            });
            yield new Z3KRadioSensorTemperature(device, {
                object_id: object.id,
            });
            yield new Z3KRadioSensorTemperatureAlarm(device, {
                object_id: object.id,
            });
            break;
    }
    yield new Z3KRadioSensorBattery(device, { object_id: object.id });
    yield new Z3KRadioSensorDbm(device, { object_id: object.id });
    // yield new Z3KRadioSensorLost(device, {object_id: object.id});
})());
export class HeatingCircuitSetpointTempGraphData extends BaseZ3K {
    class_name() {
        return 'HeatingCircuitSetpointTempGraphData';
    }
    array_name() {
        return 'heating_circuits';
    }
    title() {
        return this.get_object()?.name + ': расчётная температура';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_heating_circuit;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.setpoint_temp ?? [];
    }
    yaxis_key() {
        return 'temperature';
    }
    normalize_data(data) {
        return cf.time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)));
    }
}
export class HeatingCircuitTargetTempGraphData extends BaseZ3K {
    class_name() {
        return 'HeatingCircuitTargetTempGraphData';
    }
    array_name() {
        return 'heating_circuits';
    }
    title() {
        return this.get_object()?.name + ': целевая температура';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_heating_circuit;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.target_temp ?? [];
    }
    yaxis_key() {
        return 'temperature';
    }
    normalize_data(data) {
        return cf.time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)));
    }
}
export class HeatingCircuitWorkTimeGraphData extends BaseBoilerWorkTime {
    class_name() {
        return 'HeatingCircuitWorkTimeGraphData';
    }
    device;
    object_id;
    constructor(device, { object_id, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.device = device;
        this.object_id = object_id;
        this._color = color;
    }
    serialize_params() {
        return { object_id: this.object_id, color: this._color };
    }
    is_same(other) {
        return (this.constructor === other.constructor && this.object_id === other.object_id);
    }
    get_object() {
        return find_by_id(this.device.z3k_config()?.heating_circuits, this.object_id);
    }
    title() {
        const obj = this.get_object();
        const name = obj?.name ?? '<удалённый контур>';
        const title = obj?.type === HeatingCircuit.Type.BOILER
            ? 'работа горелки/выхода'
            : 'запрос тепла';
        return `${name}: ${title}`;
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_heating_circuit;
    }
    extract_data(raw_data) {
        return raw_data[this.object_id]?.worktime ?? [];
    }
}
export class AnalogInputVoltageGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputVoltageGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ??
            null);
    }
    title() {
        const object = this.get_object();
        const name = object?.name ?? '<неизвестный объект>';
        const title = object != null ? AnalogInput.getValueTitle(object) : 'напряжение';
        const unit = object != null ? AnalogInput.getUnit(object) : 'В';
        return `${name}: ${title}, ${unit}`;
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.value ?? [];
    }
    yaxis_key() {
        const units = this.get_object()?.units;
        const result = AnalogInput.analog_input_units.find((unit_spec) => {
            return unit_spec.value == units;
        });
        const axes = result?.axes != null ? result.axes : 'voltage';
        //@ts-ignore
        return axes;
    }
    normalize_data(data) {
        const object = this.get_object();
        const multiply = object != null ? AnalogInput.getMultiplier(object) : 1;
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, value]) => [time, value / (multiply ?? 10)]);
    }
}
export class AnalogInputResistanceGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputResistanceGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ??
            null);
    }
    title() {
        const object = this.get_object();
        const name = object?.name ?? '<неизвестный объект>';
        const title = object != null ? AnalogInput.getValueTitle(object) : 'Сопротивление';
        const units = object != null ? AnalogInput.getUnit(object) : 'Ом';
        return `${name}: ${title}, ${units}`;
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.value ?? [];
    }
    yaxis_key() {
        const units = this.get_object()?.units;
        if (units === 1)
            return 'resistanceOM';
        else if (units === 2)
            return 'pressure';
        else if (units === 3)
            return 'speed';
        else if (units === 4)
            return 'autoscan_turn';
        else if (units === 5)
            return 'liter';
        else if (units === 6)
            return 'flowPerHour';
        else if (units === 7)
            return 'percent';
        return 'resistance';
    }
    normalize_data(data) {
        const object = this.get_object();
        const multiply = object != null ? AnalogInput.getMultiplier(this.get_object()) : 1;
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, value]) => [time, value / (multiply ?? 1)]);
    }
}
export class AnalogInputPressureGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputPressureGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    title() {
        return this.get_object()?.name + ': давление';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.value ?? [];
    }
    yaxis_key() {
        return 'pressure';
    }
    normalize_data(data) {
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, value]) => [time, value / 10]);
    }
}
export class AnalogInputDiscreteGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputDiscreteGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    title() {
        return this.get_object()?.name + ': состояние';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.status ?? [];
    }
    yaxis_key() {
        return 'onoff';
    }
    normalize_data(data) {
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, status]) => [time, (status & (1 << 10)) > 0 ? 1 : 0]);
    }
    dont_downsample() {
        return true;
    }
}
export class AnalogInputAlarmButtonGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputAlarmButtonGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    title() {
        return this.get_object()?.name + ': состояние';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.status ?? [];
    }
    yaxis_key() {
        return 'pressed';
    }
    normalize_data(data) {
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, status]) => [time, (status & (1 << 1)) > 0 ? 1 : 0]);
    }
    dont_downsample() {
        return true;
    }
}
export class AnalogInputHumidityGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputHumidityGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    title() {
        return this.get_object()?.name + ': влажность';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.value ?? [];
    }
    yaxis_key() {
        return 'percent';
    }
    normalize_data(data) {
        return cf.time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)));
    }
}
export class AnalogInputFuelStatGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputFuelStatGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ??
            null);
    }
    title() {
        if (this.get_object())
            return this.get_object()?.name + ': расход топлива';
        else
            return '<удалён>';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.value ?? [];
    }
    yaxis_key() {
        return 'fuel_per_hour';
    }
    normalize_data(data) {
        const obj = this.get_object();
        const impulse_frequency = obj?.sensor_type === 16 ? obj?.impulse_frequency ?? 1 : 1;
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, value]) => [time, value / impulse_frequency]);
    }
}
export class AnalogInputSpeedGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputSpeedGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ??
            null);
    }
    title() {
        return this.get_object()?.name + ': скорость';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.value ?? [];
    }
    yaxis_key() {
        return 'speed';
    }
    normalize_data(data) {
        const object = this.get_object();
        const impulse_frequency = object?.sensor_type === 12 ? object.impulse_frequency ?? 1 : 1;
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, value]) => [time, value / impulse_frequency]);
    }
}
export class AnalogInputTurnGraphData extends BaseZ3K {
    class_name() {
        return 'AnalogInputTurnGraphData';
    }
    array_name() {
        return 'analog_inputs';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ??
            null);
    }
    title() {
        return this.get_object()?.name + ': обороты';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_analog_input;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.value ?? [];
    }
    yaxis_key() {
        return 'autoscan_turn';
    }
    normalize_data(data) {
        const object = this.get_object();
        const impulse_frequency = object?.sensor_type === 13 ? object.impulse_frequency ?? 1 : 1;
        return cf
            .time_mul_1k(cf.make_staircase(cf.normalize_time(data, 0)))
            .map(([time, value]) => [time, value / impulse_frequency]);
    }
}
export class WebElementStateBooleanGraphData extends BooleanMarkingsGraphSource {
    class_name() {
        return 'WebElementStateBooleanGraphData';
    }
    device;
    object_id;
    constructor(device, { object_id, color }) {
        // @ts-ignore
        // eslint-disable-next-line prefer-rest-params
        super(...arguments);
        this.device = device;
        this.object_id = object_id;
        this._color = color;
    }
    is_same(other) {
        return (
        //@ts-ignore
        super.is_same(...arguments) && this.object_id === other.object_id);
    }
    serialize_params() {
        return { object_id: this.object_id, color: this._color };
    }
    array_name() {
        return 'web_elements';
    }
    get_object() {
        const z3k_config = this.device.z3k_config();
        const array_name = this.array_name();
        const self = z3k_key_namespace[array_name];
        return (self.get.byId(z3k_config, this.object_id) ?? null);
    }
    predicate(value) {
        if (value && value === 1)
            return true;
        return false;
    }
    title() {
        return this.get_object()?.name + ': состояние';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_web_element;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.state ?? [];
    }
    normalize_data(data) {
        return normalize_time(data, 0);
    }
}
export class WebElementStateGraphData extends BaseZ3K {
    class_name() {
        return 'WebElementStateGraphData';
    }
    array_name() {
        return 'web_elements';
    }
    title() {
        return this.get_object()?.name + ': состояние';
    }
    color() {
        if (this._color)
            return this._color;
        return rf_color('id' + this.object_id);
    }
    data_source_key() {
        return LoadDataType.z3k_web_element;
    }
    extract_data(raw_data) {
        return raw_data?.[this.object_id]?.state ?? [];
    }
    get_analog_output() {
        return AnalogOutput.get.byId(this.device.z3k_config(), 
        //@ts-ignore
        WebElement.get.byId(this.device.z3k_config(), this.object_id)?.id_active);
    }
    yaxis_key() {
        const analog_output = this.get_analog_output();
        if (analog_output) {
            switch (analog_output.unit) {
                case 0:
                    return 'voltage';
                case 1:
                    return 'herz';
                case 2:
                    return 'temperature';
            }
        }
        return 'onoff';
    }
    normalize_data(data) {
        const analog_output = this.get_analog_output();
        let mult;
        if (analog_output)
            mult = analog_output.mult;
        else
            mult = 1;
        return cf.make_staircase(cf.time_mul_1k(cf.normalize_time(data.map((item) => [item[0], item[1] / mult]), 0)));
    }
    dont_downsample() {
        return true;
    }
}
